import React from 'react';
/**
 * This context is intended to allow information about the app
 * to be shared across various components at different levels of the tree.
 *
 * Generally speaking a single `<VarnishContext.Provider />` should be used
 * per page. More complex scenarios, however, might necessitate using multiple.
 */
export const VarnishContext = React.createContext({
    layout: 'center-aligned',
    currentHeaderHeight: 0,
    setHeaderHeight() { },
});
/**
 * A default, stateful wrapper that makes it easy to set app wide properties.
 *
 * Most of the time you should use this.
 */
export const DefaultAppLayoutProvider = ({ layout, children }) => {
    const [currentHeaderHeight, setHeaderHeight] = React.useState(0);
    return (React.createElement(VarnishContext.Provider, { value: {
            layout,
            currentHeaderHeight,
            setHeaderHeight,
        } }, children));
};
//# sourceMappingURL=VarnishContext.js.map